import React from 'react';
import { Row, Col, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { getNameWhiteLabel } from '../../../../../services/utils';

const CashPaymentInfo = ({ domain, phoneGeneral, onPhoneChange, errors }) => {
  const { t } = useTranslation();

  return (
    <Row type="flex" align="top" justify="start" className="content-row">
      <Col className="card" xs={18} sm={18} md={18} lg={18} xl={18}>
        <div className="ant-collapse-sub-header">
          {t('Information for direct cash payments with') + ' ' + getNameWhiteLabel(domain)}
        </div>
        <p>
          {t(
            'Please complete the form with your billing information and your contact telephone number, a n_label collector will contact you to coordinate the collection.'
          ).replace('n_label', getNameWhiteLabel(domain))}
        </p>
      </Col>
      <Col xs={8}>
        <p className="title-form">{t('Telephone contact')}</p>
        <Form.Item
          validateStatus={errors['phone_general'] ? 'error' : ''}
          help={errors['phone_general']}
        >
          <Input
            placeholder={t('Telephone contact')}
            autoComplete="tel"
            onChange={e => onPhoneChange(e.target.value)}
            value={phoneGeneral}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default CashPaymentInfo;
